import { render, staticRenderFns } from "./TwitterConsent.vue?vue&type=template&id=80e5b394&"
import script from "./TwitterConsent.vue?vue&type=script&lang=js&"
export * from "./TwitterConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports